import { render, staticRenderFns } from "./_taskPriorityModal.vue?vue&type=template&id=4ce97ee1"
import script from "./_taskPriorityModal.vue?vue&type=script&lang=js"
export * from "./_taskPriorityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports